import {Component, signal} from '@angular/core';
import { MdbButtonComponent } from '../../../../utils/mdb-button/mdb-button.component';
import { LinkSelectComponent } from '../../../../utils/link-select/link-select.component';
import { VehicleModel } from '../../../../../models/resources/vehicle.model';
import { UrlParamModel } from '../../../../../models/url-param.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleService } from '../../../../../services/resources/vehicle.service';
import { CustomNotificationService } from '../../../../../services/utils/custom-notification.service';
import { HttpErrorsService } from '../../../../../services/utils/http-errors.service';
import { finalize } from 'rxjs';
import { LocationModel } from '../../../../../models/resources/location.model';
import { LocationService } from '../../../../../services/resources/location.service';
import { LocationVehiclesTableComponent } from "./location-vehicles-table/location-vehicles-table.component";
import {LocationVehicleService} from "../../../../../services/resources/location-vehicle.service";
import {ConcreteResourceService} from "../../../../../services/utils/concrete-resource.service";

@Component({
  selector: 'app-location-vehicles',
  imports: [
    LocationVehiclesTableComponent,
    MdbButtonComponent,
    LinkSelectComponent,
  ],
  templateUrl: './location-vehicles.component.html',
  styleUrl: './location-vehicles.component.scss',
})
export class LocationVehiclesComponent{
  location = signal<LocationModel | null>(null);

  loading: boolean = false;
  addVehicleFormGroup: FormGroup = this.formBuilder.group({
    vehicle: [null, Validators.required]
  });

  availableVehicleQueryParams: UrlParamModel[] = [
    {key: 'without-location', value: 'true'}
  ];

  constructor(
    private locationService: LocationService,
    public vehicleService: VehicleService,
    private locationVehicleService: LocationVehicleService,
    private notificationService: CustomNotificationService,
    private formBuilder: FormBuilder,
    public httpErrorsService: HttpErrorsService,
    private concreteResourceService: ConcreteResourceService<LocationModel>
  ) {
    this.concreteResourceService.setData(this.locationService);
    this.location = this.concreteResourceService.getModel();
  }

  addVehicle() {
    this.addVehicleFormGroup.markAllAsTouched();

    if (this.addVehicleFormGroup.invalid)
      return;

    const location = this.location();
    const vehicle =
        this.addVehicleFormGroup.get('vehicle')?.value as VehicleModel;

    if (!location || !vehicle)
      return;

    this.loading = true;

    let resource = {
      ...vehicle,
      updatedAt: vehicle.updatedAt,
      location: {
        id: location.id,
        updatedAt: location.updatedAt,
      },
    };

    this.vehicleService
      .update(vehicle.id, resource, '/vehicles')
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: (vehicle) => {
          this.notificationService.success('VEHICLES.VEHICLE_SUCCESSFULLY_ADDED');
          this.addVehicleFormGroup.reset();

          this.vehicleService.getAll({
            resetData: true,
            urlParams: this.availableVehicleQueryParams,
          });

          this.locationVehicleService.addModel(vehicle)
        }
      });
  }

  refreshVehicles() {
    this.vehicleService.getAll({
      resetData: true,
      urlParams: this.availableVehicleQueryParams,
    })
  }
}
